import React from 'react'

import { mergeDeep } from '@root/utility'

import Link from '@Pure/Link'

export var form =
{
	model: 'ProductFamily'.toLowerCase(),

	form_title: 'Famille de produit',

	fields:
	{
		code:
		{
			label: 'Code unique'
		},

		label:
		{
			label: 'Libellé'
		},

		analytic:
		{
			label: 'Analytique'
		},

		analytic_label:
		{
			label: 'Intitulé (d\'Analytique)'
		},

		tracking_inventory:
		{
			label: 'Gestion des stocks',
			type: 'checkbox',
			options:
			[
				{
					value: 'oui'
				}
			],
		},

		provider:
		{
			label: 'Fournisseur',
			reference:
			{
				model: 'provider',
				referenced_field:
				{
					name: 'name',
					type: 'text'
				},
				autocomplete:
				{
					'name':
					{
						type: 'text'
					}
				}
			}
		},

		local_seller_code:
		{
			label: 'Compte de vente local'
		}
	},

	create_label: 'Créer cette famille',

	get__deleteModalText: function (form_data)
	{
		var output =
		(
			<span>
				<p>
					Êtes vous sûr de vouloir supprimer cette famille&nbsp;?
				</p>

				<div className="u-center">

					<div className="name-in-modal">

						{ form_data['category[name]'] }

					</div>

				</div>
			</span>
		);

		return output;
	},

	get__createdMessage: function (model)
	{
		var output =
		(
			<div className="c-message c-message--green">
				<div className="c-message__content">
					La nouvelle famille <strong> { model.label } </strong> a été créée.
					{ ' ' }
					<Link className="c-link c-link--highlighted c-link--green"
						href={ '/gestion-du-catalogue/familles-de-produits/' + model.id }>
						Voir la famille
					</Link>
				</div>
			</div>
		);

		return output;
	}
}

export var list =
{
	model         : 'ProductFamily'.toLowerCase(),
	title         : 'Liste des familles de produits',
	link          : '/gestion-du-catalogue/familles-de-produits',
	creation_link : '/gestion-du-catalogue/nouvelle-famille-de-produits',
	creation_label: 'Nouvelle famille',
	header_map:
	{
		'Libellé': 'label'
	},
	row_link_base: '/gestion-du-catalogue/familles-de-produits/',
	searched_prop: 'label'
};

var config = mergeDeep({ }, form);

mergeDeep(config, list);

export default config